import { useAuth, useAuthActions } from '../../state/AuthContext';
import '../../styles/auth.css';
import '../../styles/friends.css';

function AccountMenu({ onClose, onEditProfile, onAbout, onSettings }) {
  const { user, friendRequests } = useAuth();
  const { logout } = useAuthActions();

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  return (
    <>
      <div className="account-menu-header">
        <span className="account-menu-name">{user.displayName}</span>
        {user.username && <span className="account-menu-username">@{user.username}</span>}
      </div>

      <div className="account-menu-divider" />

      <button
        className="account-menu-item account-menu-btn"
        onClick={onAbout}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        About
      </button>

      <button
        className="account-menu-item account-menu-btn"
        onClick={onEditProfile}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
        Edit Profile
      </button>

      <button
        className="account-menu-item account-menu-btn"
        onClick={onSettings}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
        </svg>
        Settings
      </button>

      {friendRequests.length > 0 && (
        <div className="account-menu-item account-menu-friends-item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          Friend Requests
          <span className="account-menu-friend-badge">{friendRequests.length}</span>
        </div>
      )}

      <div className="account-menu-divider" />

      <button className="account-menu-item account-menu-btn account-menu-logout" onClick={handleLogout}>
        Sign Out
      </button>
    </>
  );
}

export default AccountMenu;
